<template>
  <section>
    <PageTitle title="Dashboard" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'//',title:'Dashboard'}]" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <AllRestaurants
                @update:selectedRestaurantId="fetchBranchesOfRestaurant"
                :placeholder="'All'"
                :return-value="'all'"
                :updateSelectedRestaurant="selectedRestaurant"
            />
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>Branches</label>
            <select class="form-control" v-model="selectedBranch">
              <option value="all">All</option>
              <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id+'_branchchoose'">
                {{branch.areasByAreaId.name}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label>City</label>
            <select :disabled="selectedBranch !== 'all'" v-model="selectedCity" class="form-control">
              <option value="all">All</option>
              <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id+'_citychoose'">
                {{city.city}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>Date Range</label>
            <input type="text" readonly="readonly" data-graph-id="10" placeholder="Select Date Range" id="date_range" class="form-control date_picker"/>
          </div>
        </div>
        <div class="col-md-1">
          <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-info btn-sm" type="button" @click="fetchGraphs"><i class="fa fa-search"></i> search</button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3">
          <HorizontalCard title="Total Orders" :stat=totalOrders card-class="blue-bg" icon="fa fa-shopping-cart fa-5x"/>
        </div>
        <div class="col-md-3">
          <HorizontalCard title="Total Sales" :stat=totalSale card-class="navy-bg" icon="fa fa-dollar fa-5x"/>
        </div>
        <div class="col-md-3">
          <HorizontalCard title="Order Cancelled" :stat=totalOrderCancelled card-class="red-bg" icon="fa fa-cart-arrow-down fa-5x"/>
        </div>
        <div class="col-md-3">
          <HorizontalCard title="Complaints" :stat=totalComplaints card-class="yellow-bg" icon="fa fa-bug fa-5x"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Date-wise Sales
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="1" id="date_range_1"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <Loader class="d-flex" v-if="!loader.includes('dateWiseSale')"/>
                  <LineChart :title="'Sale Chart'" :side-text="'Sales'" :bottom-text="'Dates'" :data="dataWiseSaleData" :categories="dataWiseSaleCategories" v-else/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Branch-Wise Orders
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="2"  id="date_range_2"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <Loader class="d-flex" v-if="!loader.includes('branchWiseOrders')"/>
                  <PieChart :title="'Number of Order In Branch'" :side-text="''" :bottom-text="''" :data="branchWiseOrder" v-else/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Sale of Last Six Month
            </div>
            <div class="panel-body">
              <Loader class="d-flex" v-if="!loader.includes('monthlySale')"/>
              <BarChart :title="'Sale of Last Six Month'" type="bar" :unit="'Rs.'" :side-text="'Sales'" :bottom-text="'Monthly Sale'" :data="monthlySaleData" :categories="monthlySaleCategories" :height="478" :color="'#b73c28'" v-else/>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Top 10 Delivery Areas
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="4" id="date_range_4"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <Loader class="d-flex" v-if="!loader.includes('topAreas')"/>
              <BarChart :title="'Top 10 Delivery Areas'" :side-text="'Number of order delivered'" :bottom-text="'Top 10 Areas'" :data="topAreasData" :categories="topAreasCategories" :color="'#3a8854'" v-else/>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Top 10 Customers
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="4" id="date_range_5"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <Loader class="d-flex" v-if="!loader.includes('topCustomers')"/>
              <BarChart :title="'Top 10 Customers'" :side-text="'Number of order placed'" :bottom-text="'Top 10 Customer'" :data="topCustomersData" :categories="topCustomersCategories" :color="'#31adf9'" @selectedBar="selectedBar" v-else/>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              New Customers in Last Six Month
            </div>
            <div class="panel-body">
              <Loader class="d-flex" v-if="!loader.includes('newCustomers')"/>
              <BarChart :title="'New Customers in Last Six Month'" :side-text="'Number of Customers'" :bottom-text="'Monthly Customer'" :data="newCustomersData" :categories="newCustomersCategories" :height="478" :color="'#5863c6'" v-else/>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Take Away & Delivery Orders
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="2" id="date_range_6"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <Loader class="d-flex" v-if="!loader.includes('orderTypeStats')"/>
                  <PieChart :title="'Number Take Away & Delivery Orders'" :side-text="''" :bottom-text="''" :data="orderTypeData" v-else/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" v-if="loggedInUserRole === 'ADMIN'">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Agents target per month stats
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-5">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="2" id="date_range_7"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="form-group ">
                    <label>Agents</label>
                    <multiselect
                        v-model="selectedAgent"
                        :options="agents"
                        label="fullName"
                        track-by="fullName"
                        :hide-selected="true"
                        :max="10"
                        :multiple="true"
                        placeholder="Select agent (Limit 10)"
                    ></multiselect>
                  </div>
                </div>
                <div class="col-md-2">
                  <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-info btn-sm"  @click="fetchAgentMonthlyStats()"><i class="fa fa-search"></i> search</button>
                </div>
              </div>
              <Loader class="d-flex" v-if="!loader.includes('agentStat')"/>
              <BarChart :title="'Agents Wise Stats'" :side-text="'Number of Total Orders'" :bottom-text="'Agents'" :data="agentData" :categories="agentCategories" :color="'#6b8abc'" v-else/>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="panel panel-primary">
            <div class="panel-heading">
              Top 10 Products Stats
            </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Date Range</label>
                    <input type="text" readonly="readonly" data-graph-id="3" id="date_range_3"  placeholder="Select Date Range" class="form-control date_picker"/>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <Loader class="d-flex" v-if="!loader.includes('topProducts')"/>
                  <BarChart :title="'Number of Order In Branch'" :side-text="'Number of Unit Sold'" :bottom-text="'Top 10 Products'" :data="topProductsData" :categories="topProductsCategories" :color="'#f28f43'" v-else/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CustomerDetails ref="CustomerDetailsPopUp"/>
  </section>
</template>
<script>
import PageTitle from "@/components/layout_components/PageTitle.vue";
import HorizontalCard from "@/components/Dashboard/HorizontalCard.vue";
import AllRestaurants from "@/components/restaurants/AllRestaurants.vue";
import {getAllBranchesOfRestaurant, getAllRestaurant} from "@/api/restaurants";
import {getAllCities} from "@/api/areas";
import moment from "moment/moment";
import LineChart from "@/components/Dashboard/LineChart.vue";
import BarChart from "@/components/Dashboard/BarChart.vue";
import PieChart from "@/components/Dashboard/PieChart.vue";
import {highCharts} from "highcharts-vue";
import {
  getBranchWiseOrders,
  getDateWiseSale, getGlobalStats, getMonthlyAgentStats,
  getNewCustomers, getOrderTypeStats, getSaleOfLastSixMonth,
  getTopAreas,
  getTopCustomers,
  getTopProducts
} from "@/api/dashboard";
import Loader from "@/components/utils/Loader.vue";
import Multiselect from "vue-multiselect";
import {getAllUsers} from "@/api/users";
import CustomerDetails from "@/components/customers/CustomerDetails.vue";

export default{
  name: "Dashboard",
  components: {
    CustomerDetails,
    Multiselect, highCharts, LineChart, AllRestaurants, HorizontalCard, PageTitle, BarChart, PieChart, Loader},
  data () {
    return {
      selectedRestaurant: "all",
      selectedBranch: "all",
      selectedCity: "all",
      defaultDate: "",
      loggedInUserRole: "",
      totalOrders: 0,
      totalSale: 0,
      totalComplaints: 0,
      totalOrderCancelled: 0,
      loader: [],
      restaurants: [],
      branches: [],
      cities: [],
      dataWiseSaleData: [],
      dataWiseSaleCategories: [],
      branchWiseOrder: [],
      topProductsData: [],
      topProductsCategories: [],
      topAreasData: [],
      topAreasCategories: [],
      topCustomersData: [],
      topCustomersCategories: [],
      customerIds: [],
      newCustomersData: [],
      orderTypeData: [],
      newCustomersCategories: [],
      monthlySaleData: [],
      monthlySaleCategories: [],
      agentData: [],
      agentCategories: [],
      selectedAgent: [],
      agents: [],
      rerenderChart: {
        'date_range_1': this.fetchDateWiseSalesGraphs.bind(this),
        'date_range_2': this.fetchBranchWiseOrders.bind(this),
        'date_range_3': this.fetchTopProducts.bind(this),
        'date_range_4': this.fetchTopAreas.bind(this),
        'date_range_5': this.fetchTopCustomers.bind(this),
        'date_range_6': this.fetchOrderTypeStats.bind(this),
        'date_range_7': this.fetchAgentMonthlyStats.bind(this),
      }
    }
  },

  computed: {
    startDateForSixMonthChart() {
      return this.newCustomersCategories.length > 0 ? this.newCustomersCategories[0] : 'loading start dates'
    },
    endDateForSixMonthChart() {
      return this.newCustomersCategories.length > 0 ? this.newCustomersCategories[this.newCustomersCategories.length-1] : 'loading end dates'
    },
  },

  created: function () {
    this.loggedInUserRole = this.$store.state.user.userRolesById[0].role.split('_')[1];
    $("body").removeClass("gray-bg");
    if (this.loggedInUserRole === 'AGENT') {
      this.$router.replace("/orders");
    }
    if (this.loggedInUserRole === 'ADMIN') {
      this.fetchAllRestaurants()
      this.getAllUsers()
    } else if (this.loggedInUserRole === 'USER') {
      this.selectedRestaurant = this.$store.state.user.restaurant.id;
      this.restaurants.push({id: this.$store.state.user.restaurant.id, name: this.$store.state.user.restaurant.name})
      this.fetchBranchesOfRestaurant(this.selectedRestaurant);
    }
    this.fetchCites()
  },

  mounted: function () {
    this.setDateRange()
    this.$nextTick(() => {
      this.fetchGraphs();
    });
    },

  methods: {
    async fetchAllRestaurants() {
      let allRestaurantResp = await getAllRestaurant();
      this.restaurants = allRestaurantResp.data;
    },

    async getAllUsers() {
      let resp = await getAllUsers();
      this.agents = resp.data && resp.data.length>0 && resp.data.filter(user => user.role === 'ROLE_AGENT');
    },

    async fetchBranchesOfRestaurant(event) {
      this.selectedRestaurant = event;
      if (this.selectedRestaurant !== "all") {
        let params = new URLSearchParams();
        params.append("restaurant_id", this.selectedRestaurant);
        let restaurantAllBranch = await getAllBranchesOfRestaurant(params);
        this.branches = restaurantAllBranch.data;
      } else {
        this.branches = [];
      }
      this.selectedBranch = "all";
    },

    async fetchCites() {
      let resp = await getAllCities()
      this.cities = resp.data;
    },

    async fetchGraphs () {
      this.defaultDate = $('#date_range').val()
      $('.date_picker').val(this.defaultDate)
      this.fetchGlobalStats()
      this.fetchDateWiseSalesGraphs()
      this.fetchBranchWiseOrders()
      this.fetchTopProducts()
      this.fetchTopAreas()
      this.fetchTopCustomers()
      this.fetchNewCustomersOfLastSixMonth()
      this.fetchOrderTypeStats()
      this.fetchSaleOfLastSixMonth()
      setTimeout(()=>{
        this.fetchAgentMonthlyStats()
      }, 200)
    },

    createParams(id) {
      let dateRange = $(`#date_range_${id}`).val().split(" <==> ")
      if (dateRange[0] === '') {
        swal("Error!", "Kindly Select Date Range", "error");
        return;
      }
      return {
        start: dateRange[0],
        end: dateRange[1],
        restaurant_id: this.selectedRestaurant,
        branch_id: this.selectedBranch,
        city_id: this.selectedCity
      }
    },

    async fetchGlobalStats() {
      try {
      let params = this.createParams(1)
      const { data } = await getGlobalStats(params)
      console.log(data)
      this.totalOrders = data.totalOrders
      this.totalComplaints = data.totalComplaints
      this.totalSale = data.totalSale
      this.totalOrderCancelled = data.totalCancelOrders
      } catch (e) {
        console.log(e)
      }
    },

    async fetchDateWiseSalesGraphs() {
      try {
        this.loader.includes("dateWiseSale") && this.loader.splice(this.loader.indexOf("dateWiseSale"), 1)
        let params = this.createParams(1)
        const resp = await getDateWiseSale(params)
        this.dataWiseSaleData = resp.data.series
        this.dataWiseSaleCategories = resp.data.categories.map(e=>this.$moment(e).format("DD-MMM-YYYY").toLowerCase())
        this.loader.push("dateWiseSale")
      } catch (e) {
        console.log(e)
      }

    },

    async fetchBranchWiseOrders() {
      try {
        this.loader.includes("branchWiseOrders") && this.loader.splice(this.loader.indexOf("branchWiseOrders"), 1)
        let params = this.createParams(2)
        const resp = await getBranchWiseOrders(params)
        this.branchWiseOrder = resp.data
        this.loader.push("branchWiseOrders")
      } catch (e) {
        console.log(e)
      }

    },

    async fetchTopProducts() {
      try {
        this.loader.includes("topProducts") && this.loader.splice(this.loader.indexOf("topProducts"), 1)
        let params = this.createParams(3)
        params.order = "desc"
        const resp = await getTopProducts(params)
        this.topProductsData = resp.data.counts
        let names = [];
        if (this.selectedRestaurant === "all") {
          names = resp.data.names.map((item, index) => {
            return item + '<br>(' + resp.data.restaurantNames[index] + ')';
          });
        } else {
          names = resp.data.names;
        }
        this.topProductsCategories = names
        this.loader.push("topProducts")
      } catch (e) {
        console.log(e)
      }
    },

    async fetchTopAreas() {
      try {
        this.loader.includes("topAreas") && this.loader.splice(this.loader.indexOf("topAreas"), 1)
        let params = this.createParams(4)
        const resp = await getTopAreas(params)
        this.topAreasData = resp.data.counts
        this.topAreasCategories = resp.data.names
        this.loader.push("topAreas")
      } catch (e) {
        console.log(e)
      }
    },

    async fetchTopCustomers() {
      try {
        this.loader.includes("topCustomers") && this.loader.splice(this.loader.indexOf("topCustomers"), 1)
        let params = this.createParams(5)
        const resp = await getTopCustomers(params)
        this.topCustomersData = resp.data.counts
        this.topCustomersCategories = resp.data.names
        this.customerIds = resp.data.ids
        this.loader.push("topCustomers")
      } catch (e) {
        console.log(e)
      }
    },

    async fetchNewCustomersOfLastSixMonth() {
      try {
        this.loader.includes("newCustomers") && this.loader.splice(this.loader.indexOf("newCustomers"), 1)
        let params = this.createParams(5)
        const resp = await getNewCustomers(params)
        this.newCustomersData = resp.data.series
        this.newCustomersCategories = resp.data.categories
        this.loader.push("newCustomers")
      } catch (e) {
        console.log(e)
      }
    },

    async fetchOrderTypeStats() {
      try {
        this.loader.includes("orderTypeStats") && this.loader.splice(this.loader.indexOf("orderTypeStats"), 1)
        let params = this.createParams(6)
        const resp = await getOrderTypeStats(params)
        this.orderTypeData = resp.data
        this.loader.push("orderTypeStats")
      } catch (e) {
        console.log(e)
      }
    },

    async fetchSaleOfLastSixMonth() {
      try {
        this.loader.includes("monthlySale") && this.loader.splice(this.loader.indexOf("monthlySale"), 1)
        let params = this.createParams(6)
        const resp = await getSaleOfLastSixMonth(params)
        this.monthlySaleData = resp.data.series
        this.monthlySaleCategories = resp.data.categories
        this.loader.push("monthlySale")
      } catch (e) {
        console.log(e)
      }
    },

    async fetchAgentMonthlyStats() {
      try {
        this.loader.includes("agentStat") && this.loader.splice(this.loader.indexOf("agentStat"), 1)
        let dateRange = $("#date_range_7").val().split(" <==> ")
        let params = new URLSearchParams();
        params.append('agent_id', this.selectedAgent.length > 0 ? this.selectedAgent.map(agent=>agent.id) : []);
        params.append('start', dateRange[0]);
        params.append('end', dateRange[1]);
        const resp = await getMonthlyAgentStats(params)
        this.agentData = resp.data.series ? resp.data.series.reverse() : []
        this.agentCategories = resp.data.categories ? resp.data.categories.reverse() : []
        this.loader.push("agentStat")
      } catch (e) {
        console.log(e)
      }
    },

    setDateRange() {
      const self = this;
      let currentDate = moment();
      let startDate = currentDate.clone().subtract(15, 'days').format('YYYY-MM-DD');
      let endDate = currentDate.format('YYYY-MM-DD');
      $('.date_picker').daterangepicker({
        format: 'YYYY-MM-DD',
        maxDate: new Date(),
        minDate: moment().subtract(3, 'months'),
        startDate: moment().subtract(15, 'days')
      }).on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
        let id = $(this).attr("id")
        if (id !== 'date_range') {
          self.rerenderChart[id]();
        }
      });
      self.defaultDate = startDate + ' <==> ' + endDate
      $('#date_range').val(self.defaultDate)
    },

    selectedBar(val) {
      let dateRange = $('#date_range_5').val().split(" <==> ")
      this.$refs.CustomerDetailsPopUp.load(this.customerIds[val], this.topCustomersCategories[val], dateRange[0], dateRange[1], this.selectedRestaurant, this.selectedBranch, this.selectedCity);
    }
  }
}
</script>

<style scoped>
.d-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>